import { withSafeSuspense } from '@calendly/safe-suspense'
import { Loader } from '@calendly/ui/components/loader'
import { lazy } from 'react'

export const RemoteContactsPane = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_rail')
    .then((module) => ({ default: module.RemoteContactsPaneMFE }))
  ), null
)

export const RemoteContactsSearchHandler = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_search_handler')
    .then((module) => ({ default: module.RemoteContactsSearchHandlerMFE }))
  ), null
)

export const RemoteFindOrCreateContactCard = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./find_or_create_contact_card')
    .then((module) => ({ default: module.RemoteFindOrCreateContactCardMFE }))
  ), null
)

export const ContactPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contact_page')
    .then((module) => ({ default: module.ContactPage }))
  ), null
)

export const ContactsSettingsPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_settings_page')
    .then((module) => ({ default: module.ContactsSettingsPageMFE }))
  ), null
)

export const CrmContainer = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts')
    .then((module) => ({ default: module.CrmContainerMFE }))
  ), null
)

export const RemoteContactCreateModal = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./create_contact_modal')
    .then((module) => ({ default: module.RemoteContactCreateModalMFE }))
  ), null
)

export const RemoteGoogleAccountSearchHandler = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteGoogleAccountSearchHandlerMFE }))
  ), null
)

export const RemoteGmailDisconnectButton = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteGmailDisconnectButtonMFE }))
  ), null
)

export const RemoteSyncReconnectButton = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteSyncReconnectButtonMFE }))
  ), null
)

export const RemoteExperimentEventTypeEditorSyncBanner = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteExperimentEventTypeEditorSyncBannerMFE }))
  ), null
)

export const RemoteExperimentShareAvailabilitySyncBanner = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteExperimentShareAvailabilitySyncBannerMFE }))
  ), null
)

export const RemoteContactCard = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contact_card')
    .then((module) => ({ default: module.ContactCardMFE }))
  ), null
)

export const RemoteContactsModalsOutlet = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./modals_outlet')
    .then((module) => ({ default: module.RemoteContactsModalsOutletMFE }))
  ), null
)

export const NeedsAttentionPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./needs_attention_page')
    .then((module) => ({ default: module.NeedsAttentionPageMFE }))
  ), null
)

// Unlike the embedded CRM widgets above (which use a `null` fallback), Action Center is a full-page
// tab, so it shows the shared `Loader` while its chunk loads to avoid a blank flash under the shell
// header on first visit.
export const ActionCenterPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./action_center_page')
    .then((module) => ({ default: module.ActionCenterPageMFE }))
  ), <Loader />
)
